import type { BoxProps } from "@mui/material";
import { Box } from "@mui/material";
import type { ReactNode } from "react";
import React, { forwardRef } from "react";
import { Helmet } from "react-helmet-async";

import i18n from "translations/i18n";

const htmlAttributes = { lang: i18n.language };

interface PageProps extends BoxProps {
  children: ReactNode;
  title?: string;
}

const Page = forwardRef<HTMLDivElement, PageProps>(({ children, title = "", ...other }, ref) => (
  <Box
    ref={ref}
    {...other}
  >
    <Helmet htmlAttributes={htmlAttributes}>
      <title>Flowls - {title}</title>
    </Helmet>
    {children}
  </Box>
));

export default Page;
